import getEnv from '@sls-react/utils/getEnv';
import fireGtagEvent from '@sls-react/services/analytics/fireGtagEvent';
import analyticsPageView from '@sls-react/services/analytics/analyticsPageView';

export default function analyticsInitialize() {
  fireGtagEvent('js', new Date());
  fireGtagEvent('config', getEnv('GA_TRACKING_ID'), {
    send_page_view: false,
  });
  analyticsPageView(window.location.pathname);
}
